import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Checkmark from 'Assets/tick.svg';

interface Props {
    items: { id: string; node: ReactNode }[];
}

const Wrapper = styled.ul`
    display: inline-block;
`;

const ChecklistItem = styled.li`
    color: ${props => props.theme.colors.charcoal100};
    margin-top: 0.5em;
    padding: 0 0 0 40px;
    font-size: 14px;
    line-height: 1.4;
    letter-spacing: 0.0425em;
    text-align: left;
    position: relative;

    b {
        font-weight: bold;
    }

    &:first-of-type {
        margin-top: 0;
    }

    &::before {
        content: '';
        display: block;
        width: 23px;
        height: 100%;
        background: url('${Checkmark}') no-repeat center left;
        background-size: 23px 14px;
        position: absolute;
        top: 0;
        left: 0;
    }
`;

const Checklist: React.FunctionComponent<Props> = ({ items }) => (
    <Wrapper>
        {items.map(item => (
            <ChecklistItem key={item.id}>{item.node}</ChecklistItem>
        ))}
    </Wrapper>
);

export default Checklist;
